export default __webpack_public_path__ + "static/media/Razor of the Divinity Serpent.b146824a.jpg";